import React, { useRef, useState } from 'react';

import axios from 'axios';
import { useTranslation } from "react-i18next";
import { useAuthDispatch, AUTH_ACTIONS} from '@app/contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';

import EmailInput from '@app/components/2_widgets/inputs/InputEmail';
import PasswordInput from '@app/components/2_widgets/inputs/InputPassword';

import ButtonPrimary from "@app/components/1_elements/ButtonPrimary";

export default function SessionNew() {
    const [isDisplayErrors, setIsDisplayErrors] = useState(false);

    const refInputEmail = useRef();
    const refInputPassword = useRef();

    const authDispatch = useAuthDispatch();
    const navigate = useNavigate();

    const { t } = useTranslation();

    function login(event) {        
        event.preventDefault();
        // Get the rails csrf token
        const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
        
        // Send data to back        
        axios.post(
            "/api/v1/sessions",
            {
                email: refInputEmail.current.getValue(),
                password: refInputPassword.current.getValue()
            },
            {
                headers: {                    
                    'X-CSRF-Token': csrfToken,
                }
            }
        )
        .then(response => {
            if (response.data.access_token) {         
                // Update the context with new user datas
                authDispatch({
                    type: AUTH_ACTIONS.LOGIN,
                    payload: {
                        token: response.data.access_token,
                        userId: response.data.user_id,
                        roles: response.data.roles,                        
                        companyId: response.data.company_id ? response.data.company_id : ""
                    }
                });
                
                // Redirection to the home page
                navigate('/');
                navigate(0); // Trick to re-render the page
            }
        })
        .catch(error => {
            setIsDisplayErrors(true);
        });
    }    

    function displayErrorMessage() {
        if (isDisplayErrors) {
            return (
                <p className="input-error-message">Identifiant ou Mot de passe incorrect</p>
            )
        }
    }

    return (
        <div id="session-new">
            <div className="row justify-content-center me-0">           
                <div className="col-xxl-3 col-lg-4 col-md-12 right-section card justify-content-center">
                    <div className="first-section">
                        <form>
                            {/* Input area */}
                            <EmailInput
                                ref={refInputEmail}                             
                                label={t("word.identity")}
                                placeholder={t("word.identity")}
                            />
                            <PasswordInput
                                ref={refInputPassword}                             
                                label={t("word.password")}
                                placeholder={t("word.password")}
                            />
                            {displayErrorMessage()}

                            <div className="text-sm-end mb-3">
                                <ButtonPrimary label={t("word.to_connect")} onClick={login} />
                            </div>
                            <div>
                                <Link to="/forgot-password" className="float-end">{t("word.forgot_password_question")}</Link>                            
                            </div>                        
                        </form>                        
                    </div>
                </div>
            </div>
        </div>    
    )
};